module.exports = __webpack_public_path__ + "static/media/6.5-inch Screenshot 2.af41ed0f.jpeg";